import {
  GET_ALL_PROMOTIONS,
  GET_ALL_PROMOTIONS_RESPONSE_SUCCESS,
  CREATE_PROMOTION,
  UPDATE_PROMOTION,
  DELETE_PROMOTION,
} from "./actionTypes"

export const getAllPromotions = () => {
  return {
    type: GET_ALL_PROMOTIONS,
  }
}
export const getAllPromotionsResponseSuccess = payload => ({
  type: GET_ALL_PROMOTIONS_RESPONSE_SUCCESS,
  payload: payload,
})

// ------------------------------------- CREATE --------------------------------------------------------

export const createPromotion = (payload, history) => {
  return {
    type: CREATE_PROMOTION,
    payload: payload,
    history,
  }
}

// ------------------------------------- EDIT --------------------------------------------------------

export const updatePromotion = (payload, history, id) => {
  return {
    type: UPDATE_PROMOTION,
    payload: payload,
    history,
    id,
  }
}

// ------------------------------------- DELETE --------------------------------------------------------

export const deletePromotion = payload => ({
  type: DELETE_PROMOTION,
  payload: payload,
})
